import React from 'react'
import { connect } from 'react-redux'
import {
  selectBusinessConfig,
  selectCreditSessionFinished,
  selectCurrentRefi,
  selectCurrentRefiUser,
  selectCurrentRefiApplication,
} from '../../reducers'
import { Redirect } from 'react-router-dom'

function areStatesAvailable(
  refiActiveStates: string[],
  userState: string | undefined
): boolean {
  return (
    refiActiveStates.includes(userState ?? '') || refiActiveStates.length === 0
  )
}

const RefiAppStatusCheck = ({
  refi,
  currentApplication,
  creditSessionFinished,
  config,
  user,
}) => {
  // disabling for now
  let disabled = true
  if (disabled) {
    return <></>
  }

  const refiActiveStates = config?.system?.refi_active_states || []
  const userAddresses = user?.addresses || []
  const userState = userAddresses.find(
    (address) => address.id === currentApplication.addressId
  )?.state

  const statesAvailable = areStatesAvailable(refiActiveStates, userState)
  const status = statesAvailable ? refi?.status?.toLowerCase() : 'unavailable'

  if (creditSessionFinished) return <></>

  switch (status) {
    case 'rejected':
      return <Redirect to="/refiapp/rejected" />
    case 'review':
      return <Redirect to="/refiapp/review" />
    case 'pending':
      return <Redirect to="/refiapp/pending" />
    case 'unavailable':
      return <Redirect to="/refiapp/unavailable" />
    default:
      return <></>
  }
}

export const mapStateToProps = (state) => ({
  refi: selectCurrentRefi(state),
  currentApplication: selectCurrentRefiApplication(state),
  creditSessionFinished: selectCreditSessionFinished(state),
  config: selectBusinessConfig(state),
  user: selectCurrentRefiUser(state),
})

export default connect(mapStateToProps)(RefiAppStatusCheck)
